// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  font-size: 1rem;
}

.container-login {
  border: 2px solid gray;
  width: 30%;
  padding: 2rem;
  margin: 1rem 0;
}

.container-create-user {
  border: 2px solid gray;
  width: 50%;
  padding: 2rem;
  margin: 1rem 0;
}

.div-login {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: .5rem 0;
}

.btn-login {
  background-color: #034ea1;
  outline: none;
  border: none;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  color: white;
  cursor: pointer;
}

.btn-login:hover {
  background-color: #002c5e;
}

.pdf-table{
    border: 1px solid gray;
    text-align: center;
    width: 16rem;
}

.pdf-table th,td{
    border: 1px solid gray;
}

.table-wrapper-create-user {
  display: flex;
  justify-content: center;
}

.table-create-user {
  font-size: .75rem;
  text-align: center;
}

.nbfc-form-control {
  border-radius: 3px;
  width: 100%;
  padding: 0.6rem 0rem;
  outline: none;
  border: 1px solid gray;
}

@media screen and (max-width: 800px) {
  .container-login {
    width: 80%;
  }

}

@media screen and (max-width: 1000px) {
  .container-create-user {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".main-login {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 100vw;\r\n  flex-direction: column;\r\n  font-size: 1rem;\r\n}\r\n\r\n.container-login {\r\n  border: 2px solid gray;\r\n  width: 30%;\r\n  padding: 2rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.container-create-user {\r\n  border: 2px solid gray;\r\n  width: 50%;\r\n  padding: 2rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.div-login {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  margin: .5rem 0;\r\n}\r\n\r\n.btn-login {\r\n  background-color: #034ea1;\r\n  outline: none;\r\n  border: none;\r\n  border-radius: 5px;\r\n  padding: 0.5rem 1rem;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-login:hover {\r\n  background-color: #002c5e;\r\n}\r\n\r\n.pdf-table{\r\n    border: 1px solid gray;\r\n    text-align: center;\r\n    width: 16rem;\r\n}\r\n\r\n.pdf-table th,td{\r\n    border: 1px solid gray;\r\n}\r\n\r\n.table-wrapper-create-user {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.table-create-user {\r\n  font-size: .75rem;\r\n  text-align: center;\r\n}\r\n\r\n.nbfc-form-control {\r\n  border-radius: 3px;\r\n  width: 100%;\r\n  padding: 0.6rem 0rem;\r\n  outline: none;\r\n  border: 1px solid gray;\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  .container-login {\r\n    width: 80%;\r\n  }\r\n\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .container-create-user {\r\n    width: 80%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
